<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
    export default {
        name: "App",

        mounted() {
            this.setPageHeight();

            let self = this;
            window.addEventListener('resize', function () {
                self.setPageHeight();
            });
            window.addEventListener('orientationchange', function () {
                self.setPageHeight();
            });
        },

        methods: {
            setPageHeight() {
                document.getElementById("app").style.minHeight = `${window.innerHeight}px`
            }
        }
    }
</script>
<style lang="scss">

</style>
